export default class Messages {
    /**
     * Constructor.
     *
     * @return {Void}
     */
    constructor() {
        jQuery('.js-ops-close-broadcast-message').on('click', this.handleCloseBroadcastMessageClick);
    }

    /**
     * Close broadcast message click event handler.
     * 
     * @param {Object} e 
     * @return {Void}
     */
    handleCloseBroadcastMessageClick(e) {
        let $el = jQuery(this);
        let $message = $el.closest(".ops-alert");
        let uid = $message.data('message-uid');
        let url = $message.data('read-url');
        let nonce = null
            || (window.OP3 && OP3.Meta ? OP3.Meta.nonce : "")
            || (window.OpsScriptData && OpsScriptData.nonce ? OpsScriptData.nonce : "")
            || "";

        // Hide the message
        $message.fadeOut();

        // The mark as read
        jQuery.ajax({
            url: url,
            method: 'post',
            data: { _wpnonce: nonce, uid: uid },
            error: function () {
                window.OPDashboard.Helpers.notify("Error occurred.", "error");
            }
        });

        e.preventDefault();
    }
}